import { Backdrop, Box, Button, CircularProgress, Stack, TextField, Checkbox, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { API } from '../../conf';
import { Context } from '../../App';

export default function RegionForm({close, showResult, setRegions, regions, region=null}) {
    const { updateConnect } = React.useContext(Context);
    const [code, setCode] = useState(region?.code || '');
    const [nom, setNom] = useState(region?.nom || '');
    const [zip, setZip] = useState(region?.zip || '');
    const [availableOnEsdras, setAvailableOnEsdras] = useState(region?.availableOnEsdras || false);
    const [communes, setCommunes] = useState(region?.communes || []);
    const [svg_path, setSvgPath] = useState(region?.svg_path || '');
    const [loading, setLoading] = useState(false);

    function handleSave(e) {
        e.preventDefault();
        setLoading(true);
        const newRegion = {code, nom, zip, availableOnEsdras, svg_path, communes};
        const url = API.concat(region?._id ? `/region/${region._id}` : '/region');
        console.log(url)
        fetch(url, {
            method: region?._id ? 'PATCH':'POST',
            headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: JSON.stringify(newRegion)
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token);
                }
                if (response.status === 200) {
                    const json = await response.json();
                    if (json) {
                        setRegions(prev => region ? prev.map(r => r._id === region._id ? json : r) : [...prev, json]);
                    }
                    showResult(Boolean(json));
                } else {
                    showResult(false);
                }
            }
        }).catch(error => {
            console.error("Error saving region:", error);
            showResult(false);
        }).finally(() => {
            setLoading(false);
            close(); // Close the form after saving
        });
    }

    return (
        <Box component={'form'} onSubmit={handleSave} sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding:2, minWidth: '200px' }}>

            <Stack direction="row" gap={1} flex={1} flexWrap='wrap' alignItems="center">
                <TextField variant='filled' label='Nom' value={nom} onChange={(e) => setNom(e.target.value)} required sx={{flexBasis:0, flexGrow:3, minWidth:'200px'}} />
                <TextField label='Code ISO' value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} required sx={{flexBasis:0, flexGrow:1, minWidth:'100px'}} />
                <TextField label='Code postal' value={zip} onChange={(e) => setZip(e.target.value.toUpperCase())} required sx={{flexBasis:0, flexGrow:1, minWidth:'150px'}} />
            </Stack>

            <TextField variant='filled' label='path SVG' value={svg_path} onChange={(e) => setSvgPath(e.target.value)} fullWidth />
            {svg_path.length > 0 && <svg width="100%" height="200" viewBox="0 0 134 150" xmlns="http://www.w3.org/2000/svg">
                <path d={svg_path} />
            </svg>}
            
            <Button
                variant="outlined"
                component="label"
                sx={{ alignSelf: 'flex-start', mb: 1 }}
            >
                Importer les communes (csv)
                <input
                    type="file"
                    accept=".csv"
                    hidden
                    onChange={async (e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        const text = await file.text();
                        // Simple CSV parsing: split by commas, trim, ignore empty
                        // Parse CSV with headers: zip, nom
                        const lines = text.trim().split('\n');
                        const header = lines[0].split(';').map(h => h.trim().toLowerCase());
                        const nomIndex = header.indexOf('nom');
                        const zipIndex = header.indexOf('zip');
                        if (nomIndex === -1 || zipIndex === -1) {
                            alert("Le fichier CSV doit contenir les entêtes 'zip' et 'nom'.");
                            return;
                        }
                        const importedCommunes = lines.slice(1)
                            .map(line => {
                                const cols = line.split(';');
                                const nom = cols[nomIndex]?.trim();
                                const zip = cols[zipIndex]?.trim();
                                return (nom && zip) ? {zip, nom} : null;
                            })
                            .filter(Boolean);
                        console.log(importedCommunes);
                        setCommunes(importedCommunes);
                    }}
                />
            </Button>
            { communes.length > 0 && <Typography variant="body2" color="textSecondary">{communes.length} communes importées</Typography>}

            <Stack direction="row" spacing={1} alignItems="center">
                <Checkbox
                    checked={availableOnEsdras}
                    onChange={(e) => setAvailableOnEsdras(e.target.checked)}
                    color="primary"     
                    inputProps={{ 'aria-label': 'available on Esdras7' }}
                />
                <Typography>Disponible sur Esdras7</Typography>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="center" justifyContent={'flex-end'}>
                <Button variant="outlined" onClick={close}>annuler</Button>
                <Button variant="contained" color="primary" type="submit" disabled={loading}>
                    {loading && <CircularProgress size={24} />} Enregistrer
                </Button>
            </Stack>

            <Backdrop open={loading}><CircularProgress/></Backdrop>
        </Box>
    );
}